/**
 * 加载数据相关
 */
import { message } from "antd";
import request from "@src/common/request";
import BanModal from "@/components/modal/ban";
import Core from "./core";
import md5 from "md5";
import Conf from "../conf";

const Loader = {
  // 上传头像大小限制
  maxAvatarSizeM : 5,
  maxAvatarSize : 5 * 1024 * 1024,

  // 发送消息
  messageLimit : 2000,

  /**
   * 创建角色
   */
  // 昵称长度限制
  nicknameLengh : 16,
  // 角色简介长度限制
  descriptionLength : 40,
  // 问候语长度限制
  greetingLength : 200,
  // 角色定义长度限制
  promptLength : 2048,
  // AI 学习网址
  trainUrlsLength : 10,
  // AI 学习微博
  trainWeiboLength : 10,
  // AI 学习资料
  trainFilesLength : 100,

  // 学习状态
  learnStatus : {
    learning : 0, // 学习中
    success : 1,  // 学习成功
    fail : 2,     // 学习失败
  },

  defaultChatTilte : "新建对话",

  previewPromissionMsg : "没有查看内容的权限",

  // 距离底部 > n 时，不再自动滚动
  autoScrollToBottomGap : 100,

  // 知识库数字人信息
  knowledgeRobotInfo : {
    title : "知识库小助手",
    icon : "https://p5.ssl.qhimg.com/t11098f6bcdbae68e45a21dd340.png"
  },

  defaultModelIcon : 'https://p1.ssl.qhimg.com/t110b9a93018295fdd8f951fb2c.png',

  // 尺寸配置
  size : {
    chatSmall : 1100,          // 小于该尺寸后，会话页按钮不显示文本
    rightSmall : 500 + 460,   // 小于该尺寸后，右侧 html 预览占满，不显示 chat
    actionSmall : 580,        // 小于该尺寸后，耗时/消耗 token 折行
    minHtml : 500,            // 右侧 html 最小宽度
  },

  /**
   * toast 接口报错信息
   * @param {String|Object} msg 
   */
  error(msg) {
    console.error('Loader error:', msg);
    if(!msg){
      return;
    }

    if (typeof msg == "object") {
      if(msg.code == '100011'){
        BanModal.show();
        return;
      }
      msg = Loader.getErrmsg(msg);
    }
    message.error(msg);
  },

  /**
   * 服务端的 code => msg
   * @param {Object} res 
   */
  getErrmsg(res) {
    const { code, msg, message } = res;

    return msg || message;
  },

  /**
   * 是否机器人
   */
  isRobot (user) {
    if(!user){
      return false;
    }
    return user.user_type == "robot" || user.role == "robot";
  },

  /**
   * 获取单个机器人信息
   * @param {String} robot_id
   */
  getRobotInfo (robot_id) {
    if(!robot_id){
      throw new Error(`获取机器人信息，ID 不可为空`);
    }

    return request.get("/robots/info", {
      params : {
        uid : robot_id,
      },
    })
    .then(res => {
      return res.data[robot_id];
    });
  },

  /**
   * 角色权限
   */
  roleVisitAuth : [
    {
      id : 1,
      name : "公开",
      ename : "open",
    },
    {
      id : 2,
      name : "非公开",
      ename : "noopen",
    },
    {
      id : 3,
      name : "私密",
      ename : "private",
    },
  ],
  roleVisitAuthList : {
    open : 1,
    noopen : 2,
    private : 3,
  },

  /**
   * 机器人头像背景色
   */
  robotAvatarBgColors : [
    // ["red", "green"],  // debug
    ["#FFCB52", "#FF7B02"],
    ["#FFE324", "#FFB533"],
    ["#C165DD", "#5C27FE"],
    ["#2AFEB7", "#08C792"],
    ["#FF9470", "#FF5B3D"],
    ["#5581F1", "#1153FC"],
    ["#ADF082", "#75DC4B"],
  ],
  getRobotAvatarBgColor (nickname) {
    if(!nickname?.length){
      return this.robotAvatarBgColors[0];
    }

    let hash = 0, chr;
    for (let i = 0, len = nickname.length; i < len; i++) {
      chr = nickname.charCodeAt(i);
      hash = ((hash << 5) - hash) + chr;
      hash |= 0;
    }
    return this.robotAvatarBgColors[hash % this.robotAvatarBgColors.length];
  },

  /**
   * 是否 Mj 机器人
   * @param {Object} robot 
   */
  isMj (robot) {
    return robot?.chat_type == 3;
  },
  /**
   * 是否 prompt 机器人
   * @param {Object} robot 
   */
  isPrompt (robot) {
    return robot?.chat_type == 2;
  },
  /**
   * 普通机器人
   * @param {Object} robot 
   */
  isTextRobot (robot) {
    return robot && !this.isMj(robot) && !this.isPrompt(robot);
  },

  /**
   * 跳转到校验失败的位置
   */
  gotoInvalidForm (errorFields = []) {
    if(!errorFields?.length){
      return;
    }
    const firstErrorField = errorFields[0];
    const fieldName = firstErrorField.name?.[0];
    if(!fieldName){
      return;
    }
    const $ele = document.querySelector(`#${fieldName}[aria-invalid='true']`);
    if($ele){
      $ele.scrollIntoView();
    }
    const errmsg = firstErrorField.errors?.[0];
    if(errmsg){
      message.error(errmsg);
    }
  },

  /**
   * 隐私授权
   */
  getPrivacyRole (type) {
    return request.get("/privacy/roles", {
      params : {
        privacy : type,
      },
    })
    .then((res) => {
      return res.data?.[type] == 1;
    })
    .catch(res => {
      console.error("查询隐私授权失败", res);
      return null;
    });
  },
  setPrivacyRole (type) {
    return request.post("/privacy/roles", {
      privacy : type,
    })
    .then((res) => {
    })
    .catch((err) => {
      message.error(err.msg);
    });
  },

  /**
   * 处理大模型返回中，不符合 md 格式的链接，后面加空格分隔
   * @param {String} content 
   */
  regexSplitUrl : /(\[?(https?:\/\/)?(www\.)?[a-zA-Z0-9]+\.[a-z]{2,}\/?([^\s\u4e00-\u9fa5|\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]*))/g,
  splitUrlInMarkdown (content) {
    if(!content){
      return content;
    }
    return content.replace(this.regexSplitUrl, ($1) => {
      if($1.startsWith("[")){
          return $1;
      }
      return `${$1} `;
    })
  },
  /**
   * 拼接网站 favicon.ico
   * @param {String} url 
   */
  getFavIcon (url) {
    const defaultUrl = "https://p4.ssl.qhimg.com/t01a0f1af1327b93bf6.png";
    if(!url){
      return defaultUrl;
    }
    let _url;
    try{
      _url = new URL(url);
      if(!_url.origin){
        return defaultUrl;
      }
      // 如果来自图床
      if(/qhimg/.test(_url.origin)){
        return url;
      }
    } catch(e){
      return defaultUrl;
    }
    return `https://so.n.cn/api/proxy/icon?${Core.param({
      icon : `${_url.origin}/favicon.ico`,
    })}`;
  },

  /**
   * 获取卫士知识库文档预览地址
   * @param {Object} knowledgeItem 
   */
  getFilePriviewUrl (knowledgeItem) {
    if(!knowledgeItem?.file_id){
      return null;
    }

    // file-preview 老版本，不需要传 folder-id，可能有安全漏洞
    // wps-preview 新版本，必传 folder-id
    return `${import.meta.env.VITE_WEISHI_HOST}/knowledge-base/wps-preview?${Core.param({
      "file-id" : knowledgeItem.file_id,
      "file-type" : (Core.getFileNameExt(knowledgeItem.file_name) || "").toLowerCase(),
      "file-name" : knowledgeItem.file_name,
      "ks-id": knowledgeItem.ks_id || "",
      "folder-id": knowledgeItem.folder_id || "",
    })}`
  },

  getKnowledgeInfo : async (folder_id) => {
    return request.post("/knw_cloud/inRouter/v1/knowledge/datasets/detail", {
      folder_id,
    }, {
      dataIsJson : true,
      headers : {
        "Header-Tid" : Loader.getAssistantHeaderTid(),
      },
    })
    .then(res => {
      const { data } = res;
      return data;
    })
    .catch(() => null)
  },

  /**
   * 知识库名称处理，去掉前后斜杠
   * @param {String} name 
   */
  getFixedKnowledgeName (name) {
    if(!name || typeof name != "string"){
      return "";
    }
    return name.replace(/^\//, "")
      .replace(/\/$/, "")
      .replace(/^我的知识库$/, "个人知识库")
  },

  /**
   * 会话页样式
   * @param {Object} options 
   */
  getChatContainerStyle (options, isMessage) {
    if(!options){
      return {};
    }

    const {
      isKnowledgeChat,
      showRightPanel,
    } = options;

    const style = {};
    if(showRightPanel){
      if(isMessage){
        style.minWidth = 0;
      }
      else {
        style.minWidth = 400;
      }
    }
    else if(isKnowledgeChat){

    }
    else {
      style.minWidth = 652;
      style.minWidth = 400;
    }

    if(Core.isPhone()){
      style.minWidth = 0;
    }

    return style;
  },

  /*
   * 模型信息
   * @param {Object} modelInfo 
   * @returns 
   */
  getModelIcon (modelInfo) {
    if(!modelInfo){
      return this.defaultModelIcon;
    }
    return modelInfo.dl_icon || modelInfo.icon || modelInfo.images || this.defaultModelIcon;
  },

  resources : {
    loading : {
      blue : "https://p0.ssl.qhimg.com/t11098f6bcd7e3bd1baa4952772.png",
      red : "https://p1.ssl.qhimg.com/t11098f6bcd4edd531ca1556acb.png",
      black : "https://p1.ssl.qhimg.com/t11098f6bcd854eba5be3052458.png",
    }
  },

  /**
   * 调用 AI 搜索接口
   * @param {String} uri 
   */
  getAISoUri (uri) {
    const pathname = Core.getUrlWithOutParams(uri);
    const urlParams = Core.getParams(uri);
    urlParams.appsource = "so";
    return `${pathname}?${Core.param(urlParams)}`;
  },

  /**
   * 调用助手接口 Header-Tid
   */
  getAssistantHeaderTid () {
    const tid = md5(Core.uniqueId());
    return tid;
  },

  /**
   * 是否支持动态网页
   * @param {String} roleId 
   */
  isDynamicPageRole (roleId) {
    return [Conf.roleIds.dynamicPage, Conf.roleIds.dynamicPage2].includes(roleId);
  },
}

export default Loader;